VP = window.VP || {};

(function( $ ) {
	VP.submenuList = {
		init: function () {
			var _this = this;


			$(".vp-submenu-list-wrap").each(function() {
        if ($(this).find("li").length <= 4) {
          $(this).addClass("tooshort");
          $(this).find(".vp-submenu-list__open").remove();
        }
        else {
  				$reveal = $(this).find(".submenu-reveal");
  				cheight = $reveal.height();
          $reveal.data("fullheight",cheight);
          $reveal.addClass("collapsed");
         	// console.log("setting height to: " + cheight);

  				$open = $(this).find(".vp-submenu-list__open");
  				$open.click(function() {
  					if ($(this).data("clicked")) {
  						return;
  					}
  					$(this).data("clicked", true);
  					$open.fadeOut(200);
  					$parent = $(this).parents(".vp-submenu-list-wrap");
  					$reveal = $parent.find(".submenu-reveal");
  					$items = $parent.find(".vp-submenu-list__items");


  					thisheight = $reveal.data("fullheight");
  					// console.log("expand to: " + thisheight);

  					if (thisheight != "" && thisheight) {
              $reveal.animate({
                height: thisheight
              }, 1000, function() {
                $reveal.height("auto");
                $reveal.addClass("expanded").removeClass("collapsed");
             });
            }
            else {
              $reveal.height("auto");
              $reveal.addClass("expanded").removeClass("collapsed");
            }

  				});
        }

			});

			 _this.eventHandlers();
			 setTimeout(_this.resizeList, 1000); // exec resize to allow for page shifting/column adjustments
		},
		resizeList: function() {

      $(".vp-submenu-list-wrap:not(.tooshort)").each(function() {
        $reveal = $(this).find(".submenu-reveal");
  			$reveal.removeClass("collapsed");
  			cheight = $reveal.height();
        $reveal.data("fullheight",cheight);
        $reveal.addClass("collapsed");
        // console.log("resize list: "+ cheight);
      });
		},
    eventHandlers: function() {
	      var _this = this;
	      VP.documentEvents.onResize( _this.resizeList.bind( _this ), true );

	  }
	};
})(jQuery);
